import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.css';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import smallArrowWhite from '#/assets/icons/small-arrow-white.svg';
import useOutsideClick from '#/hooks/useClickOutside';

import { useTranslation } from "react-i18next";


function Button({
  children,
  buttonType,
  action,
  isDisabled,
  disabledText,
  isDropDown = false,
  noMargin = false,
  ...props
}) {
  const TYPES = {
    primary: 'primary',
    secondary: 'secondary',
  };

  const listRef = useRef(null);
  const buttonRef = useRef(null);
  
  const [isOpen, setOpen] = useState(false);

  const { t } = useTranslation();

  
  useOutsideClick(listRef, buttonRef, toggle, isOpen);

  function toggle() {
    setOpen(!isOpen);
  }


  return (
    <div className={styles.wrapper}>
      <button
        ref={buttonRef}
        className={[
          styles.button,
          styles[TYPES[buttonType]],
          isDisabled && styles.disabled,
          noMargin ? styles.noMargin : ''
        ].join(' ')}
        onClick={() => !isDropDown ? action() : toggle() }
        disabled={isDisabled}
        title={isDisabled ? disabledText : ''}
        {...props}>
        {children}
        {
          isDropDown &&  <img alt="" className={isOpen ? styles.dropdownUp: styles.dropdownIcon} src={smallArrowWhite}/>
        }
      </button>
      <TransitionGroup>
        {isOpen && (
          <CSSTransition
            unmountOnExit={true}
            in={isOpen}
            timeout={120}
            classNames={{
              enter: styles['move-enter'],
              enterActive: styles['move-enter-active'],
            }}>
              <ul ref={listRef} className={styles.listWrapper} onClick={() => toggle()}>
                <li className={styles.listItem} onClick={()=> action()}>
                  {t('SAVE')}
                </li>
                <li className={styles.listItem} onClick={()=> action(true)}> 
                  {t('SAVE_AND_SHARE')}
                </li>
              </ul>
          
          </CSSTransition>
        )}
      </TransitionGroup>
    </div>
 
    
  );
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  buttonType: PropTypes.string,
  action: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

Button.defaultProps = {
  buttonType: 'primary',
  isDisabled: false,
};

export default Button;
